import { Outlet } from 'react-router'
import Header from '../header'

const PageLayout = ({top, bottom}) => {
  return (
    <div className="webBody">
      <Header bottomTabs={bottom} topTabs={top}/>
      <Outlet />
    </div>
  )
}

export default PageLayout
